// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getMultiPartnerModelRequestToJson, getMultiPartnerModelResponseFromJson, getPartnerModelRequestToJson, getPartnerModelResponseFromJson, searchPartnerModelsRequestToJson, searchPartnerModelsResponseFromJson, updatePartnerModelRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getPartnerModel(request) {
    const raw = await fetchRpc('partner.v1.PartnerModelService/GetPartnerModel', getPartnerModelRequestToJson(request));
    return getPartnerModelResponseFromJson(raw);
}
export function getPartnerModel$(request, options) {
    return defer(() => getPartnerModelWithTransport$(getGlobalTransport(), request, options));
}
export function getPartnerModelWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerModelService/GetPartnerModel', getPartnerModelRequestToJson(request), options)
        .pipe(map(resp => getPartnerModelResponseFromJson(resp)));
}
export async function getMultiPartnerModel(request) {
    const raw = await fetchRpc('partner.v1.PartnerModelService/GetMultiPartnerModel', getMultiPartnerModelRequestToJson(request));
    return getMultiPartnerModelResponseFromJson(raw);
}
export function getMultiPartnerModel$(request, options) {
    return defer(() => getMultiPartnerModelWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiPartnerModelWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerModelService/GetMultiPartnerModel', getMultiPartnerModelRequestToJson(request), options)
        .pipe(map(resp => getMultiPartnerModelResponseFromJson(resp)));
}
export async function updatePartnerModel(request) {
    await fetchRpc('partner.v1.PartnerModelService/UpdatePartnerModel', updatePartnerModelRequestToJson(request));
}
export function updatePartnerModel$(request, options) {
    return defer(() => updatePartnerModelWithTransport$(getGlobalTransport(), request, options));
}
export function updatePartnerModelWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerModelService/UpdatePartnerModel', updatePartnerModelRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function searchPartnerModels(request) {
    const raw = await fetchRpc('partner.v1.PartnerModelService/SearchPartnerModels', searchPartnerModelsRequestToJson(request));
    return searchPartnerModelsResponseFromJson(raw);
}
export function searchPartnerModels$(request, options) {
    return defer(() => searchPartnerModelsWithTransport$(getGlobalTransport(), request, options));
}
export function searchPartnerModelsWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerModelService/SearchPartnerModels', searchPartnerModelsRequestToJson(request), options)
        .pipe(map(resp => searchPartnerModelsResponseFromJson(resp)));
}
